window.app = window.app || {};

window.app.activitiesList = {
  api: {
    content: 'https://public-dot-blazepod-apps-85c6f.uc.r.appspot.com/public/v1/contents',
    filters: 'https://public-dot-blazepod-apps-85c6f.uc.r.appspot.com/public/v1/filters'
  },
  data: window.sessionStorage.getItem('bpActivities') ? JSON.parse(window.sessionStorage.getItem('bpActivities')) : [],
  filtersData: window.sessionStorage.getItem('bpActivitiesFilters') ? JSON.parse(window.sessionStorage.getItem('bpActivitiesFilters')) : [],
  lastUpdated: window.sessionStorage.getItem('bpActivitiesTS') ? Number(window.sessionStorage.getItem('bpActivitiesTS')) : null,
  translation: window.activitiesTranslations,
  creatorsConfig: [],
  el: {
    body: document.querySelector('body'),
    hero: document.querySelector('.mt-activities-hero'),
    section: document.querySelector('.mt-activities-list'),
    content: document.querySelector('.mt-activities-list__content'),
    loadMoreWrapper: document.querySelector('.mt-activities-list__action'),
    loadMore: document.querySelector('.mt-activities-list__load-more'),
    filters: document.querySelector('.mt-activities-filters'),
    filtersWrapper: document.querySelector('.mt-activities-list__filters'),
    filtersToggleBtn: document.querySelector('.mt-activities-list__filters-btn'),
    filtersClearBtns: document.querySelectorAll('[data-clear]'),
    filtersOverlay: document.querySelector('.mt-activities-filters__overlay'),
    filtersBackBtn: document.querySelector('.mt-activities-filters__back-btn'),
    filtersGroupsTitle: document.querySelector('.mt-activities-filters__groups-title'),
    filtersGroupsWrapper: document.querySelector('.mt-activities-filters__groups'),
    filtersGroupsClear: document.querySelector('.mt-activities-filters__groups-clear'),
    filtersGroups: document.querySelectorAll('.mt-activities-filters__group'),
    quickFilters: document.querySelector('.mt-featured-filters'),
    quickFiltersSlider: document.querySelector('.mt-featured-filters .swiper'),
    customBanners: document.querySelectorAll('.mt-activity-banner'),
    customBannersClose: document.querySelectorAll('.mt-activity-banner__close'),
    modal: {
      el: document.querySelector('.mt-modal--activity'),
      wrapper: document.querySelector('.mt-activity-info'),
      wrapperTop: document.querySelector('.mt-activity-info-top'),
      title: document.querySelector('.mt-activity-info__title'),
      authorName: document.querySelector('.mt-activity-info__author-name span:nth-child(1)'),
      authorSubtitle: document.querySelector('.mt-activity-info__author-name span:nth-child(2)'),
      authorImage: document.querySelector('.mt-activity-info__author-image'),
      fields: document.querySelector('.mt-activity-info__list--fields'),
      goals: document.querySelector('.mt-activity-info__list--goals'),
      setupPlayers: document.querySelector('.mt-activity-info__setup-item[data-type="players"]'),
      setupPods: document.querySelector('.mt-activity-info__setup-item[data-type="pods"]'),
      setupDuration: document.querySelector('.mt-activity-info__setup-item[data-type="duration"]'),
      gallery: document.querySelector('.mt-activity-info__gallery'),
      gallerySwiper: document.querySelector('.mt-activity-gallery'),
      galleryWrapper: document.querySelector('.mt-activity-gallery .swiper-wrapper'),
      shareButton: document.querySelector('.mt-activity-info__action.mt-activity__action-share'),
      saveButton: document.querySelector('.mt-activity-info__action.mt-activity__action-save')
    }
  },

  fetchActivites: async function () {
    try {
      const data = await (await fetch(this.api.content)).json();
      const shuffle = arr => {
        for (let i = arr.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
      };

      window.activitiesCreators.forEach(creator => {
        if (!creator.app_id || !creator.name) return;
        data.forEach(activity => {
          if (creator.app_id === activity.app_user_id) activity.creator = creator.name;
        });
      });

      this.data = shuffle(data);
      window.sessionStorage.setItem('bpActivities', JSON.stringify(this.data));
      window.sessionStorage.setItem('bpActivitiesTS', Date.now());
    } catch (e) {
      console.error("Error fetching activities:", e.message || e);
    }
  },

  fetchFilters: async function () {
    try {
      const data = await (await fetch(this.api.filters)).json();
      this.filtersData = [
        ...data,
        ...this.filtersData,
        { group_name: 'Activity Creator', element: this.creatorsConfig.map(filter => filter.title) }
      ];
      window.sessionStorage.setItem('bpActivitiesFilters', JSON.stringify(this.filtersData));
    } catch (e) {
      console.error("Error fetching filters:", e.message || e);
    }
  },

  render: function () {
    const _this = this;
    const defaultAvatar = window.activitesCreatorsAvatar ? window.activitesCreatorsAvatar : '';
    let contentHtml = '';

    if (_this.data.length === 0) return;

    // Update items per page
    let itemsPerPage = Number(_this.el.content.dataset.page);
    let itemsPerLoad = Number(_this.el.content.dataset.loadMore);
    const breakpointsPerPage = [
      { min: 550, max: 992, correction: 1, lmCorrection: 0 },
      { min: 993, max: 1179, correction: 0, lmCorrection: 0 },
      { min: 1180, max: 1360, correction: -3, lmCorrection: -2 }
    ];
    const matchingBreakpoint = breakpointsPerPage.find(({ min, max }) => window.innerWidth >= min && window.innerWidth < max);
    if (matchingBreakpoint) {
      itemsPerPage += matchingBreakpoint.correction;
      itemsPerLoad += matchingBreakpoint.lmCorrection;
      _this.el.content.dataset.page = itemsPerPage;
      _this.el.content.dataset.loadMore = itemsPerLoad;
    }

    // Update creators (config)
    _this.creatorsConfig = [
      { title: 'BlazePod Activities', includes: ['BlazePod'] },
      { title: 'Community Activities', includes: [...new Set(_this.data.filter(item => item.creator !== 'BlazePod').map(item => item.creator))] }
    ];

    // Activities list
    const checkFilter = (filter, vars) => {
      const [category, value] = filter.split(':');
      return (vars[category] && vars[category].includes(value));
    };
    let visibleActivitesCount = 0;
    let filteredData = [];
    
    _this.data.forEach(({ cover, creator, app_user_id, fields, goals, media, name, share_link }, i) => {
      // Pre-selected filters
      let itemVisible = true;
      if (_this.el.section.dataset.filtersPreselected && _this.el.section.dataset.filtersPreselected !== '') {
        const filterType = _this.el.section.dataset.filtersPreselected.split(':')[0].trim();
        const filterValue = _this.el.section.dataset.filtersPreselected.split(':')[1].trim();
        if (filterType === 'creators') {
          itemVisible = (app_user_id === filterValue || (filterValue === 'blazepod' && creator === 'BlazePod'));
          itemVisible && filteredData.push(_this.data[i]);
          _this.creator.update({ author: creator, appId: filterValue }, 'profile', true);
        } else {
          itemVisible = checkFilter(_this.el.section.dataset.filtersPreselected, { fields, goals });
          itemVisible && filteredData.push(_this.data[i]);
        }
      }
      
      // Creator details
      let creatorObj = activitiesCreators.find(cr => cr.app_id === app_user_id) || (activitiesCreators.find(cr => cr.name === creator) || { name: creator, subtitle: '', image: defaultAvatar });
      (creatorObj.name !== creator) && (creatorObj.name = creator);
      creatorObj.image.includes('no-image') && (creatorObj.image = defaultAvatar);

      // Item
      const itemSlug = _this.utilities.handleize(`${name}-${creatorObj.name}`);
      const itemCustomLink = `${window.location.origin}${window.location.pathname}?aid=${itemSlug}`;
      const item = document.createElement('div');
      item.classList = (visibleActivitesCount < itemsPerPage) ? 'mt-activity' : 'mt-activity hidden';
      item.dataset.id = i;
      item.dataset.app_id = itemSlug;
      _this.data[i].id = i;
      _this.data[i].app_id = itemSlug;
      _this.data[i].activity_link = itemCustomLink;

      // Media (Gallery)
      const itemMedia = document.createElement('div');
      itemMedia.classList = 'mt-activity__media';
      cover && (itemMedia.innerHTML = `<img src="${cover}" alt="${name}" loading="lazy">`);

      const itemVideo = media.filter(m => m.type === 'video');
      if (itemVideo.length > 0) {
        const itemMediaVideo = document.createElement('video');
        itemMediaVideo.setAttribute('data-src', itemVideo[0].url);
        itemMediaVideo.setAttribute('playsinline', '');
        itemMediaVideo.setAttribute('muted', '');
        itemMediaVideo.setAttribute('loop', '');
        itemMediaVideo.setAttribute('controlsList', 'nofullscreen nodownload noremoteplayback');
        itemMedia.appendChild(itemMediaVideo);
      }

      // Main content
      const itemContent = document.createElement('div');
      itemContent.classList = 'mt-activity__content';

      // Actions
      const itemActions = document.createElement('div');
      itemActions.classList = 'mt-activity__actions';

      // Title
      const itemTitle = document.createElement('p');
      itemTitle.classList = 'mt-activity__title';
      itemTitle.innerHTML = name;

      // Fields
      const itemFields = document.createElement('p');
      itemFields.classList = 'mt-activity__fields';
      itemFields.innerHTML = fields.join(' • ');

      // Goals
      const itemGoals = document.createElement('p');
      itemGoals.classList = 'mt-activity__goals';
      itemGoals.innerHTML = goals.join(' • ');

      // Info button
      const itemInfoButton = document.createElement('button');
      itemInfoButton.classList = 'mt-activity__info-button';
      itemInfoButton.type = 'button';

      // Action: Author
      const itemActionAuthor = document.createElement('div');
      itemActionAuthor.classList = 'mt-activity__action mt-activity__action-author';
      itemActionAuthor.dataset.appId = creatorObj.app_id || creator;
      itemActionAuthor.dataset.type = creatorObj.app_id ? 'id' : 'name';
      itemActionAuthor.dataset.title = creator;
      if (creatorObj.handle && !creatorObj.handle.includes('th-creator')) {
        itemActionAuthor.dataset.page = `${window.Shopify.routes.root}pages/training-hub/${creatorObj.handle}`;
      }      
      itemActionAuthor.innerHTML = `<img src="${creatorObj.image}" alt="${creator}">`;
      itemActions.appendChild(itemActionAuthor);
         
      // Action: Share
      const itemActionShare = document.createElement('a');
      itemActionShare.classList = 'mt-activity__action mt-activity__action-share';
      itemActionShare.href = itemCustomLink;
      itemActions.appendChild(itemActionShare);

      // Action: Save (open in app)
      if (share_link !== null) {
        const itemActionSave = document.createElement('a');
        itemActionSave.classList = 'mt-activity__action mt-activity__action-save';
        itemActionSave.href = share_link;
        itemActions.appendChild(itemActionSave);
      }

      // Info
      const itemInfo = document.createElement('div');
      itemInfo.classList = 'mt-activity__info';
      itemInfo.innerHTML = `<div class="mt-activity__author">
          <div class="mt-activity__author-image"><img src="${creatorObj.image}" alt="${creator}"></div>
          <p class="mt-activity__author-name"><span>${creator}</span><span>${creatorObj ? creatorObj.subtitle : ''}</span></p>
        </div>`;

      // Custom banner
      const banner = [..._this.el.customBanners].find(b => b.getAttribute('data-index') == i);
      const bannerId = banner ? `th_banner_${banner.dataset.id}` : null;

      // Build activity card
      itemMedia.appendChild(itemActions);
      itemContent.appendChild(itemTitle);
      itemContent.appendChild(itemFields);
      itemContent.appendChild(itemGoals);
      item.appendChild(itemMedia);
      item.appendChild(itemContent);
      if (banner) {
        const visibleOnlyOnce = (banner.getAttribute('data-visible-once') == 'true');
        if (!visibleOnlyOnce || (visibleOnlyOnce && !window.localStorage.getItem(bannerId))) {
          contentHtml += banner.outerHTML;
        }
      }
      itemVisible && (contentHtml += item.outerHTML);
      visibleActivitesCount++;
    });
    (_this.el.section.dataset.filtersPreselected && _this.el.section.dataset.filtersPreselected !== '') && (_this.data = filteredData);

    // No results
    const noResults = document.createElement('div');
    noResults.classList = 'mt-activities-list__no-results';
    noResults.innerHTML = `<p>No matches found for selected filters</p>`;
    contentHtml += noResults.outerHTML;

    _this.el.content.innerHTML = contentHtml;

    _this.createEvents();
    _this.updateVariables.activityTitle();
    _this.loadMore.init();
  },

  createEvents: function () {
    const _this = this;
    const items = document.querySelectorAll('.mt-activity');
    const isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
    const updateItemWidth = () => {
      const item = document.querySelector('.mt-activity:not(.hidden)');
      if (!item) return;
      _this.el.section.style.setProperty('--activity-width', item.offsetWidth + 'px');
    };
    const debounce = (func, delay) => {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), delay);
      };
    };
    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        const item = entry.target;
        const itemVideo = item.querySelector('.mt-activity__media video');
        if (itemVideo && entry.intersectionRatio > 0) {
          if (itemVideo.getAttribute('data-src') !== null) {
            itemVideo.setAttribute('src', itemVideo.getAttribute('data-src'));
            itemVideo.setAttribute('preload', 'auto');
            itemVideo.removeAttribute('data-src');
            itemVideo.load();
          }
        }
        if (window.innerWidth <= 768 && itemVideo.getAttribute('src') !== '' && entry.intersectionRatio > 0.2) {
          item.classList.add('mt-activity--video-visible');
          itemVideo.play();
          setTimeout(() => isVideoPlaying(itemVideo) ? itemVideo.removeAttribute('controls') : itemVideo.setAttribute('controls', true), 200);
        }
        if (itemVideo && itemVideo.getAttribute('src') !== '' && entry.intersectionRatio <= 0.7) {
          item.classList.remove('mt-activity--video-visible');
          itemVideo.pause();
        }
      });
    };
    const observer = new IntersectionObserver(observerCallback, {
      root: null,
      rootMargin: "0px",
      threshold: [0, 0.5, 1],
    });

    // Items
    items.forEach((item, i) => {
      const itemData = _this.data.find(el => el.id === Number(item.dataset.id));

      // Item media (video)
      const itemVideo = item.querySelector('.mt-activity__media video');
      if (itemVideo) {
        observer.observe(item);
        item.addEventListener('mouseenter', () => itemVideo.play());
        item.addEventListener('mouseleave', () => itemVideo.pause());
        itemVideo.addEventListener('play', () => itemVideo.removeAttribute('controls'));

        // Load first 5 videos
        if (i < 5 && itemVideo.getAttribute('data-src') !== null) {
          itemVideo.setAttribute('src', itemVideo.getAttribute('data-src'));
          itemVideo.removeAttribute('data-src');
          itemVideo.load();
        }
      }

      // Save button 
      const saveButton = item.querySelector('.mt-activity__action-save');
      saveButton && saveButton.addEventListener('click', () => {
        // DL events
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'video_open_in_app',
          video_name: itemData.name,
          video_fields: itemData?.fields.join(',') || '',
          video_activity_goals: itemData?.goals.join(',') || ''
        });
      });
      
      // Item x Modal
      item.addEventListener('click', e => {
        if (e.target.classList.contains('mt-activity__action')) return;
        e.preventDefault();

        const itemData = _this.data.find(el => el.id === Number(item.dataset.id));
        _this.showActivityModal(itemData);
      });

      // Item info (mobile)
      const itemInfoBtn = item.querySelector('.mt-activity__info-button');
      itemInfoBtn?.addEventListener('click', e => {
        e.preventDefault();
        item.classList.add('active');
      });

      // Item info - close (mobile)
      const itemInfoClose = item.querySelector('.mt-activity-details__close');
      itemInfoClose?.addEventListener('click', e => {
        e.preventDefault();
        item.classList.remove('active');
      });

      // Creator box & share box
      const itemAuthor = item.querySelector('.mt-activity__action-author');
      const itemShare = item.querySelector('.mt-activity__action-share');
      const creatorBox = document.querySelector('.mt-activity-creator-box');
      const shareBox = document.querySelector('.mt-share-box');
      const hideTooltip = (force = false) => {
        const isHoveredTooltip = document.querySelector('.mt-activity-creator-box:hover, .mt-share-box:hover');
        const isHoveredBtn = itemAuthor.matches(':hover') || false;

        if (!isHoveredTooltip && !isHoveredBtn || force) {
          item.classList.remove('tooltip-visible');
          _this.creator.hide('box');
          shareBox?.classList.add('hidden');
        } else if (itemAuthor.matches(':hover')) {
          item.classList.add('tooltip-visible');
          setTimeout(() => _this.creator.show('box'), 75);
          shareBox?.classList.add('hidden');
        } else if (itemShare.matches(':hover')) {
          item.classList.add('tooltip-visible');
          _this.creator.hide('box');
          shareBox?.classList.remove('hidden');
        }
      };      

      // Creator
      itemAuthor.addEventListener('click', () => {
        hideTooltip(true);
      
        const { page, title } = itemAuthor.dataset;
        const appId = item.dataset.id;
        if (page) {
          window.top.location = page;
          return;
        }
      
        _this.creator.filter(title);
        _this.creator.update({ author: title, appId, item });
      });

      itemAuthor.addEventListener('mouseenter', () => {
        if (window.innerWidth < 768) return;
        hideTooltip();
        _this.creator.update({
          author: itemAuthor.dataset.title,
          appId: item.dataset.id,
          item: item
        }, 'box');
        item.classList.add('tooltip-visible');
      });
      itemAuthor.addEventListener('mouseleave', () => setTimeout(hideTooltip, 100));

      // Share
      itemShare?.addEventListener('click', e => {
        e.preventDefault();

        const itemRect = item.getBoundingClientRect();
        const itemPosition = {
          top: itemRect.top + window.scrollY,
          left: itemRect.left + window.scrollX
        };
        shareBox.style.top = itemPosition.top + 114 + 'px';
        shareBox.style.left = itemPosition.left + (itemRect.width - 32) - (shareBox.offsetWidth / 2) + 'px';
        shareBox.classList.remove('to-right');
  
        const boxRect = shareBox.getBoundingClientRect();
        const isBoxOverflowing = boxRect.right > window.innerWidth;
        if (isBoxOverflowing) {
          shareBox.style.left = itemPosition.left + itemRect.width - shareBox.offsetWidth + 24 + 'px';
          shareBox.classList.add('to-right');

          if (window.innerWidth < 768) {
            shareBox.style.left = 'auto';
            shareBox.style.right = '16px';
          }
        }

        _this.tooltip.update('', itemShare.href);
        item.classList.add('tooltip-visible');
        shareBox.classList.remove('hidden');

        // DL events
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'video_share',
          video_name: itemData.name,
          video_fields: itemData?.fields.join(',') || '',
          video_activity_goals: itemData?.goals.join(',') || ''
        });
      });
      itemShare?.addEventListener('mouseleave', () => {
        setTimeout(hideTooltip, 100);
      });

      item.addEventListener('mouseleave', () => hideTooltip());
      creatorBox.addEventListener('mouseleave', () => {
        item.classList.remove('active');
        item.classList.remove('tooltip-visible');
        shareBox.classList.add('hidden');
        _this.creator.hide('box');
      });
    });

    // Modal: share button
    _this.el.modal.shareButton && _this.el.modal.shareButton.addEventListener('click', e => {
      e.preventDefault();

      const itemDataJson = JSON.parse(_this.el.modal.el.dataset.activity);
      const itemData = _this.data.find(el => el.id === Number(itemDataJson.appId));
      if (navigator.clipboard && itemData) {
        navigator.clipboard.writeText(_this.el.modal.shareButton.href);
        const tooltip = _this.el.modal.shareButton.querySelector('.tooltip');
        tooltip && tooltip.remove();
        const el = document.createElement('div');
        el.classList.add('tooltip');
        el.innerText = "Copied to clipboard!";
        _this.el.modal.shareButton.appendChild(el);
        setTimeout(() => el.classList.add('active'), 1);
        setTimeout(() => el.classList.remove('active'), 2000);
        setTimeout(() => el.remove(), 2300);

        // DL events
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'video_share',
          video_name: itemData.name,
          video_fields: itemData?.fields.join(',') || '',
          video_activity_goals: itemData?.goals.join(',') || ''
        });
      }
    });

    // Modal: author
    const modalAuthorEls = [_this.el.modal.authorImage, _this.el.modal.authorName];
    modalAuthorEls.forEach(el => {
      el.addEventListener('click', () => {
        if (document.querySelector('.template-th_creator, .training-hub-profile')) return;

        const activity = JSON.parse(_this.el.modal.el.dataset.activity);
        if (activity.handle && !activity.handle.includes('th-creator')) {
          window.top.location = `${window.Shopify.routes.root}pages/training-hub/${activity.handle}`;
          return;
        }
        
        _this.creator.filter(activity.author);
        _this.creator.update(activity);
        app.modal.close(_this.el.modal.el);
      });
    });

    // Modal: save button
    _this.el.modal.saveButton && _this.el.modal.saveButton.addEventListener('click', () => {
      const itemData = _this.data.find(el => el.id === Number(_this.el.modal.el.dataset.itemId));
      
      // DL events
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'video_open_in_app',
        video_name: itemData.name,
        video_fields: itemData?.fields.join(',') || '',
        video_activity_goals: itemData?.goals.join(',') || ''
      });
    });

    if (_this.el.modal.wrapper && _this.el.modal.wrapperTop) {
      _this.el.modal.wrapper.addEventListener('scroll', () => {
        _this.el.modal.wrapperTop.classList.toggle('mt-activity-info-top--sticky', _this.el.modal.wrapper.scrollTop > 0);
      });
    }

    // Items 
    updateItemWidth();
    _this.updateVariables.activityTitle();
    window.addEventListener('resize', debounce(() => {
      _this.updateVariables.activityTitle();
      updateItemWidth();
    }, 200));

    // Copy to clipboard & tooltips
    _this.tooltip.init();

    // Creator
    _this.creator.init();
    _this.el.filtersWrapper.addEventListener('mouseleave', e => {
      if (window.innerWidth < 992) return;
      _this.el.filtersGroups.forEach(g => {
        g.removeAttribute('open');

        const groupFilters = g.querySelector('.mt-activities-filters__group-search__input');
        if (groupFilters) {
          groupFilters.value = '';
          groupFilters.dispatchEvent(new Event('input', { bubbles: true }));
        }

        const groupSelectedOptions = g.querySelectorAll('.mt-activities-filters__filter.is-checked');
        groupSelectedOptions.forEach(gso => {
          gso.classList.add('is-first');
        });
      });
    });

    // Custom banners
    _this.el.customBanners = _this.el.content.querySelectorAll('.mt-activity-banner');
    _this.el.customBanners.forEach(banner => {
      const bannerId = banner ? `th_banner_${banner.dataset.id}` : null;
      const videoWrapper = banner.querySelector('.mt-activity-banner__video');
      const video = videoWrapper?.querySelector('video');
      const pauseVideoOnExit = () => {
        if (!videoWrapper || !video) return;
  
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) {
              video.pause();
            }
          });
        }, { threshold: 0 });
    
        observer.observe(videoWrapper);
      };
      
      (banner.dataset.videoInside === 'false') && (banner.dataset.lity = false);

      if (banner.dataset.videoInside === 'true') {
        banner.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();

          videoWrapper.classList.remove('hidden');
          video.play();
          pauseVideoOnExit();
        }, { once: true });
      }

      // Close button
      const closeButton = banner.querySelector('.mt-activity-banner__close');
      if (closeButton) {
        const visibleOnlyOnce = (banner && banner.getAttribute('data-visible-once') == 'true');

        closeButton.addEventListener('click', e => {
          e.preventDefault();
          (visibleOnlyOnce && bannerId) && window.localStorage.setItem(bannerId, 'true');
          banner && banner.remove();
        });
      }
    });
    document.dispatchEvent(new CustomEvent('mt-reinit-lity', {}));

    // Show activity modal (URL support)
    if (window.location.search !== '') {
      const urlParams = new URLSearchParams(window.location.search);
      const activitySlug = urlParams.get('aid');
      if (activitySlug === null) return;

      const itemData = _this.data.find(item => item.app_id === activitySlug);
      itemData && _this.showActivityModal(itemData, false);
    }

    // Back navigation
    window.addEventListener('popstate', () => {
      if (!_this.el.body.classList.contains('training-hub-profile')) return;
      app.activitiesList.creator.hide('profile');
      app.activitiesList.filters.clear(true, 'all');
    });
  },

  updateVariables: {
    activityTitle: () => {
      const itemTitles = document.querySelectorAll('.mt-activity:not(.hidden) .mt-activity__title');
      itemTitles.forEach(title => {
        const item = title.closest('.mt-activity');
        item.style.setProperty('--title-height', `${title.offsetHeight}px`);
      });
    }
  },

  showActivityModal: function (itemData = null, triggerEvents = true) {
    if (!itemData || !this.el.modal.el) return;
  
    const _this = this;
    const modal = _this.el.modal;
    const defaultAvatar = window.activitesCreatorsAvatar || '';
    const creators = window.activitiesCreators || [];
  
    let creatorObj = creators.find(cr => cr.app_id === itemData.app_user_id) 
      || creators.find(cr => cr.name === itemData.creator) 
      || { name: itemData.creator, subtitle: '', image: defaultAvatar };
  
    // Ensure creator name and fallback avatar
    creatorObj.name = itemData.creator;
    if (creatorObj.image.includes('no-image')) {
      creatorObj.image = defaultAvatar;
    }
  
    // Set modal dataset
    modal.el.dataset.activity = JSON.stringify({ appId: itemData.id, author: creatorObj.name, handle: creatorObj.handle || '' });
  
    // Build gallery HTML
    const mainVideo = itemData.media.find(m => m.type === 'video');
    const galleryMedia = mainVideo
      ? [mainVideo, ...itemData.media.filter(m => m.type !== 'video')]
      : itemData.media;
  
    const galleryHtml = galleryMedia.map(media => {
      const isVideo = media.type === 'video';
      return `
        <div class="swiper-slide">
          <figure class="mt-activity-gallery__item mt-activity-gallery__item--${isVideo ? 'video' : 'image'}">
            ${isVideo 
              ? `<video src="${media.url}" class="mt-activity-gallery__video" playsinline autoplay muted loop></video>`
              : `<img src="${media.url}" class="mt-activity-gallery__image" alt="">`}
          </figure>
        </div>`;
    }).join('');
  
    // Fields and goals HTML
    const fieldsHtml = itemData.fields.map(f => `<li class="mt-activity-info__list-item">${f}</li>`).join('');
    const goalsHtml = itemData.goals.map(g => `<li class="mt-activity-info__list-item">${g}</li>`).join('');
  
    // Setup players, pods, duration
    const setupMapping = [
      { el: modal.setupPlayers, value: itemData.settings.players },
      { el: modal.setupPods, value: itemData.settings.pods },
      { el: modal.setupDuration, value: itemData.settings.duration ? `${itemData.settings.duration / 1000}s` : null }
    ];
  
    setupMapping.forEach(({ el, value }) => {
      if (!el) return;
      if (value) {
        el.querySelector('strong').innerHTML = value;
        el.classList.remove('hidden');
      } else {
        el.classList.add('hidden');
      }
    });
  
    // Share and save buttons
    const buttons = [
      { el: modal.shareButton, link: itemData.activity_link },
      { el: modal.saveButton, link: itemData.share_link }
    ];
  
    buttons.forEach(({ el, link }) => {
      el.classList.add('hidden');
      if (link) {
        el.href = link;
        el.classList.remove('hidden');
      }
    });
  
    // Destroy old slider
    if (_this.modalSlider) _this.modalSlider.destroy(true, true);
  
    // Inject modal content
    modal.title.innerHTML = itemData.name;
    modal.authorImage.innerHTML = `<img src="${creatorObj.image}" alt="${itemData.creator}">`;
    modal.authorName.innerHTML = itemData.creator;
    modal.authorSubtitle.innerHTML = creatorObj.subtitle || '';
    modal.fields.innerHTML = fieldsHtml;
    modal.goals.innerHTML = goalsHtml;
    modal.galleryWrapper.innerHTML = galleryHtml;
  
    // Init Swiper
    _this.modalSlider = new Swiper(modal.gallerySwiper, {
      slidesPerView: 1,
      spaceBetween: 0,
      direction: 'horizontal',
      speed: 800,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });
  
    // Open modal
    _this.utilities.callFnWhenAvailable('app.modal.open', (openFn) => openFn(modal.el));
  
    // Update URL
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('aid', itemData.app_id);
    history.pushState({}, "", currentUrl);
  
    // Push DL event
    if (triggerEvents) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'video_click',
        video_name: itemData.name,
        video_fields: itemData.fields?.join(',') || '',
        video_activity_goals: itemData.goals?.join(',') || ''
      });
    }
  },  

  quickFilters: function () {
    const _this = this;
    if (!_this.el.quickFiltersSlider) return;

    // All fields
    if (_this.el.quickFilters.dataset.showAllFields === 'true') {
      const fields = _this.filtersData.find(d => d.group_name === 'Activity Field');
      const fieldsCustomAdded = [..._this.el.quickFilters.querySelectorAll('.mt-featured-filters__item input[name="fields[]"]')].map(i => i.value);
      const getInitials = name => name.split(' ').length === 1 ? name.substring(0, 2).toUpperCase() : name.split(' ').map(word => word[0].toUpperCase()).join('');
      if (fields?.element.length > 0) {
        const fieldsWrapper = _this.el.quickFiltersSlider.querySelector('.swiper-wrapper');
        let fieldsHtml = '';
        fields.element.forEach(field => {
          if (fieldsCustomAdded.includes(field)) return;
          const fieldInitials = getInitials(field);
          
          fieldsHtml += `<div class="swiper-slide">
            <label class="mt-featured-filters__item">
              <input type="checkbox" name="fields[]" value="${field}">
              <div role="button" title="${field}">
                <span class="mt-featured-filters__item-image">${fieldInitials}</span>
                <span class="mt-featured-filters__item-title">${field}</span>
              </div>
            </label>
          </div>`;
        });
        fieldsWrapper.innerHTML += fieldsHtml;
      }
    }

    _this.quickFiltersSlider = new Swiper(_this.el.quickFiltersSlider, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      freeMode: true,
      breakpoints: {
        768: {
          freeMode: false,
          slidesPerView: 7
        },
        980: {
          freeMode: false,
          slidesPerView: 8,
          spaceBetween: 30
        },
        1100: {
          freeMode: false,
          slidesPerView: 9
        },
        1200: {
          freeMode: false,
          slidesPerView: 10
        },
        1300: {
          freeMode: false,
          slidesPerView: 11
        }
      },
      navigation: {
        nextEl: '.mt-activities-list__quick-filters-btn--next',
        prevEl: '.mt-activities-list__quick-filters-btn--prev'
      }
    });

    _this.filters.syncQuickFilters();
  },

  filters: {
    availableItems: 0,
    allFiltersCount: 0,
    setup: {
      goals: [],
      fields: [],
      creators: []
    },

    clear: function (filter = false, group = 'all') {
      const _this = app.activitiesList;
      let filters = _this.el.filters?.querySelectorAll('.mt-activities-filters__filter');
      let quickFilters = _this.el.quickFilters?.querySelectorAll('input');

      if (group !== 'all') {
        filters = _this.el.filters?.querySelectorAll(`.mt-activities-filters__group[data-type="${group}"] .mt-activities-filters__filter`);
        quickFilters = _this.el.quickFilters?.querySelectorAll(`input[name="${group}[]"]`);
      } 

      filters && filters.forEach(label => {
        label?.classList.remove('active-partially');
        label?.classList.remove('is-checked');
        label?.classList.remove('is-first');
        label.querySelector('input').checked = false;
      });

      quickFilters && quickFilters.forEach(input => {
        input.checked = false;
      });
      
      filter && _this.filters.filter();
    },

    updateGroupIndicator: function () {
      app.activitiesList.creatorsConfig.forEach(group => {
        const groupInput = document.querySelector(`input[name="creators[]"][value="${group.title}"]`);
        const groupLabel = groupInput?.closest('.mt-activities-filters__filter');
        let commonFilters = 0;

        this.setup.creators.forEach(f => {
          commonFilters += (group.includes.includes(f)) ? 1 : 0;
        });

        groupLabel?.classList.toggle('active-partially', commonFilters > 0 && commonFilters !== group.includes.length);
        groupInput && (groupInput.checked = (commonFilters === group.includes.length && commonFilters !== 0));
      });
    },

    update: function (availableFilters = null, filterName = null) {
      const areFiltersEmpty = (obj) => Object.values(obj).every(value => Array.isArray(value) && value.length === 0);   
      app.activitiesList.el.filtersGroups = document.querySelectorAll('.mt-activities-filters__group');
      app.activitiesList.el.filtersGroups.forEach(group => {
        const groupFilters = group.querySelectorAll('.mt-activities-filters__filter');
        const groupInputs = group.querySelectorAll('.mt-activities-filters__filter input');
        const groupFirstLoad = (group.dataset.fgl !== 'true' && areFiltersEmpty(this.setup));
        const anyFilterChecked = ([...groupInputs].some(gi => gi.checked));

        groupFilters.forEach(filter => {
          const input = filter.querySelector('input');
          const creatorsGroups = app.activitiesList.creatorsConfig.filter(group => group.title === input.value);
          const filterValues = (creatorsGroups.length > 0) ? creatorsGroups[0].includes : [input.value];
          let isVisible = true;

          switch (input.name) {
            case 'fields[]':
              isVisible = availableFilters?.fields.includes(input.value);
              break;
            case 'goals[]':
              isVisible = availableFilters?.goals.includes(input.value);
              break;
            case 'creators[]':
              isVisible = availableFilters?.creators.some(el => filterValues.includes(el));
              break;
          }

          if (input.name === filterName && anyFilterChecked) return;
          if (availableFilters === null || isVisible) {
            filter.classList.remove('disabled');
          } else {
            filter.classList.add('disabled');
            input.checked = false;

            if (input.name === 'creators[]') {
              this.setup.creators = this.setup.creators.filter(i => i !== input.value);
            }

            groupFirstLoad && filter.remove();
          }
        });

        groupFirstLoad && (group.dataset.fgl = false);
      });
      this.updateGroupIndicator();
    },

    filter: function (filters = null, filterName = null) {
      const _this = this;
      const inputs = app.activitiesList.el.filters.querySelectorAll('input');
      const items = document.querySelectorAll('.mt-activity');
      const itemsPerPage = Number(app.activitiesList.el.content.dataset.page);
      let availableFilters = null;
      let filteredItems = app.activitiesList.data;

      if (inputs.length === 0 || items.length === 0) return;

      // Clear filters
      _this.setup = (filters !== null) ? filters : { goals: [], fields: [], creators: [] };

      // Map active top filters
      const activeTopFilters = document.querySelectorAll('.mt-featured-filters input:checked');
      activeTopFilters.forEach(topFilter => {
        let filterType = 'creators';
        (topFilter.name === 'fields[]') && (filterType = 'fields');
        (topFilter.name === 'goals[]') && (filterType = 'goals');
        _this.setup[filterType] = [...new Set([..._this.setup[filterType], topFilter.value])];
      });

      inputs.forEach(input => {
        if (!input.checked) return;

        const creatorsGroups = app.activitiesList.creatorsConfig.filter(group => group.title === input.value);
        const filterValues = (creatorsGroups.length > 0) ? creatorsGroups[0].includes : [input.value];

        switch (input.name) {
          case 'goals[]':
            !_this.setup.goals.includes(input.value) && _this.setup.goals.push(input.value);
            break;
          case 'fields[]':
            !_this.setup.fields.includes(input.value) && _this.setup.fields.push(input.value);
            break;
          case 'creators[]':
            filterValues.forEach(value => !_this.setup.creators.includes(value) && _this.setup.creators.push(value));
            break;
        }
      });

      // Update filters selection
      _this.updateGroupIndicator();

      // Update filters count
      _this.allFiltersCount = (_this.setup.goals.length + _this.setup.fields.length + _this.setup.creators.length);
      app.activitiesList.el.filtersClearBtns.forEach(btn => {
        btn.dataset.count = _this.allFiltersCount;
        btn.classList.toggle('hidden', (_this.allFiltersCount > 0));
      });
      app.activitiesList.el.filters.classList.toggle('mt-activities-filters--filtered', (_this.allFiltersCount > 0));
      app.activitiesList.el.section.setAttribute('data-filters-active', (_this.allFiltersCount > 0));

      // Creator profile
      if (_this.setup.creators.length === 0 || _this.setup.creators.length > 1) {
        app.activitiesList.creator.hide('profile');
      }

      // Filter
      const typesConfig = {
        goals: { filterKey: 'goals', filterMethod: (item, values) => item.goals.some(i => values.includes(i)) },
        fields: { filterKey: 'fields', filterMethod: (item, values) => item.fields.some(i => values.includes(i)) },
        creators: { filterKey: 'creators', filterMethod: (item, values) => values.includes(item.creator) },
      };
      Object.keys(_this.setup).forEach(type => {
        const { filterKey, filterMethod } = typesConfig[type];
        const values = _this.setup[filterKey];
        const group = document.querySelector(`.mt-activities-filters__group[data-type="${type}"]`);
        const groupIndicators = [...group?.querySelectorAll('[data-count]'), ...app.activitiesList.el?.filtersGroupsWrapper.querySelectorAll(`.mt-activities-filters__groups-clear[data-clear="${filterKey}"]`)];

        if (values.length > 0) {
          filteredItems = filteredItems.filter(item => filterMethod(item, values));
        }
      
        // Set group indicators
        groupIndicators?.forEach(gi => gi.setAttribute('data-count', values.length));
      });

      // Create dedicated URL
      const dedicatedUrl = _this.updateURLWithSetup(_this.setup);
      history.pushState({}, "", dedicatedUrl);

      // Show only filtered items
      items.forEach(item => {
        item.classList.add('hidden');
        item.dataset.filterVisible = 0;
      });
      if (filteredItems.length > 0) {
        availableFilters = { goals: [], fields: [], creators: [] };
        let visibleItems = 0;
        filteredItems.forEach(item => {
          const itemEl = document.querySelector(`.mt-activity[data-id="${item.id}"]`);
          if (itemEl) {
            itemEl.dataset.filterVisible = 1;
            if (visibleItems < itemsPerPage) {
              itemEl.classList.remove('hidden');
              visibleItems++;
            }
          }

          // Get possible filters
          availableFilters.fields = availableFilters?.fields.concat(item.fields.filter(item => !availableFilters.fields.includes(item)));
          availableFilters.goals = availableFilters?.goals.concat(item.goals.filter(item => !availableFilters.goals.includes(item)));
          (!availableFilters.creators.includes(item.creator)) && availableFilters?.creators.push(item.creator);
        });
        app.activitiesList.el.section.classList.remove('mt-activities-list--empty');
      } else {
        app.activitiesList.el.section.classList.add('mt-activities-list--empty');
      }

      // Update available activities count
      const filtersLabel = app.activitiesList.el.filtersToggleBtn.querySelector('p');
      _this.availableItems = filteredItems.length;
      filtersLabel.innerHTML = (window.activitiesTranslations.filterDrills.replace('{count}', `<strong>${_this.availableItems}</strong>`));

      _this.update(availableFilters, filterName);
      Object.values(_this.setup).every(g => g.length === 0) && _this.clear();
      app.activitiesList.results = filteredItems.length;
      app.activitiesList.loadMore.update();
      app.activitiesList.updateVariables.activityTitle();
      document.dispatchEvent(new CustomEvent('mt-activities-filter', {}));
    },

    syncQuickFilters: function () {
      const _this = this;
      const qfWrapper = document.querySelector('.mt-featured-filters');
      if (!qfWrapper) return;

      const data = {
        creators: app.activitiesList.data.reduce((p, item) => [...new Set([...p, item.creator])], []),
        fields: app.activitiesList.data.reduce((p, item) => [...new Set([...p, ...item.fields])], []),
        goals: app.activitiesList.data.reduce((p, item) => [...new Set([...p, ...item.goals])], [])
      };
      let featuredFilters = qfWrapper.querySelectorAll('.mt-featured-filters__item');

      featuredFilters.forEach(filter => {
        const filterInput = filter.querySelector('input');
        let filterType = 'creators';
        (filterInput.name === 'fields[]') && (filterType = 'fields');
        (filterInput.name === 'goals[]') && (filterType = 'goals');

        // Update input value (for creators)
        if (filterType === 'creators' && !data.creators.includes(filterInput.value)) {
          const matchedCreator = window.activitiesCreators.find(creator => creator.app_id === filterInput.dataset.id);
          matchedCreator && (filterInput.value = matchedCreator.name);
        }

        // Events
        if (data[filterType].includes(filterInput.value)) {
          filterInput.addEventListener('change', () => {
            const mainFilterGroup = app.activitiesList.creatorsConfig.find(i => i.includes.includes(filterInput.value));
            const mainFilter = document.querySelector(`.mt-activities-filters__group[data-type="${filterInput.name.replace('[]', '')}"] input[value="${filterInput.value}"]`);
            const mainGroupFilter = mainFilterGroup ? document.querySelector(`input[name="${filterInput.name}"][value="${mainFilterGroup.title}"]`) : null;
            
            mainFilter.checked = filterInput.checked;
            (!mainFilter.checked && mainGroupFilter) && (mainGroupFilter.checked = false);

            _this.filter(null, `${filterInput.name}`);
          });
        } else {
          filter.closest('.swiper-slide').remove();
        }
      });

      featuredFilters = qfWrapper.querySelectorAll('.mt-featured-filters__item');
      (featuredFilters.length > 0) ? qfWrapper.classList.remove('hidden') : qfWrapper.remove();
    },

    parseEntryUrl: function () {
      if (window.location.search !== '') {
        const urlParams = new URLSearchParams(window.location.search);
        const supportedFilters = {
          fields: 'fields[]', 
          goals: 'goals[]', 
          creators: 'creators[]'
        };

        const inputsToBeChecked = this.getInputsToBeChecked(urlParams, supportedFilters);
        this.checkInputs(inputsToBeChecked);
      }

      app.activitiesList.filters.filter();
    },

    getInputsToBeChecked: function (urlParams, supportedFilters) {
      let inputsToBeChecked = [];
      urlParams.forEach((values, key) => {
        if (!Object.keys(supportedFilters).includes(key)) return;

        const splittedValues = values.split('+');
        splittedValues.forEach(value => {
          const inputs = document.querySelectorAll(`input[name="${supportedFilters[key]}"]`);
          const matchingInputs = [...inputs].filter(i => i.value.toLowerCase() === value.toLowerCase());
          inputsToBeChecked = inputsToBeChecked.concat(matchingInputs);
        });
      });
      return inputsToBeChecked;
    },

    checkInputs: function (inputsToBeChecked) {
      inputsToBeChecked.forEach(input => {
        const label = input.closest('.mt-activities-filters__filter');
        input.checked = true;
        label?.classList.add('is-checked');
        label?.classList.add('is-first');
      });
    },

    updateURLWithSetup: function (setup = null) {
      const currentUrl = new URL(window.location.href);
      for (const key in setup) {
        if (setup.hasOwnProperty(key)) {
          const values = setup[key];

          if (Array.isArray(values) && values.length > 0) {
            const paramValue = values.map(v => v.toLowerCase()).join('+');
            currentUrl.searchParams.set(key, paramValue);
          } else {
            currentUrl.searchParams.delete(key);
          }
        }
      }
      return currentUrl.href;
    },

    init: function () {
      const _this = app.activitiesList;

      // Render filters
      const searchIconHTML = document.querySelector('.mt-activites-icons .mt-icon--search')?.outerHTML || '';
      const defaultAvatar = window.activitesCreatorsAvatar || '';
      _this.filtersData.forEach(({ group_name, element }) => {
        const gr_name = window.activitiesFilters.names[group_name] || group_name;
        const handleizedName = _this.utilities.handleize(gr_name);

        // Create group container
        const group = document.createElement('details');
        group.className = 'mt-activities-filters__group';
        group.dataset.type = handleizedName;

        // Title
        const groupTitle = document.createElement('summary');
        groupTitle.className = 'mt-activities-filters__group-title';
        groupTitle.innerHTML = `${gr_name}<span data-count></span>`;

        // Content container
        const groupContent = document.createElement('div');
        groupContent.className = 'mt-activities-filters__group-content';

        // Search
        const groupSearch = document.createElement('div');
        groupSearch.className = 'mt-activities-filters__group-search';

        const searchInput = document.createElement('input');
        searchInput.type = 'text';
        searchInput.placeholder = `Search ${gr_name}...`;
        searchInput.className = 'mt-activities-filters__group-search__input';

        const searchButton = document.createElement('button');
        searchButton.type = 'button';
        searchButton.className = 'mt-activities-filters__group-search__button';
        searchButton.innerHTML = searchIconHTML;

        groupSearch.append(searchInput, searchButton);

        // Summary
        const groupSummary = document.createElement('div');
        groupSummary.className = 'mt-activities-filters__group-summary';
        groupSummary.innerHTML = `
          <p><span data-count></span> selected</p>
          <button type="button" data-clear="${handleizedName}">Clear</button>`;

        // Filters container
        const groupFilters = document.createElement('div');
        groupFilters.className = 'mt-activities-filters__group-filters';

        // Add filters
        element.forEach(el => {
          groupFilters.appendChild(createFilterLabel(el, handleizedName));

          if (group_name === 'Activity Creator') {
            const subCreators = _this.creatorsConfig.find(i => i.title === el)?.includes || [];

            subCreators.forEach(creator => {
              const creatorObj = window.activitiesCreators.find(c => c.name === creator);
              const creatorName = creatorObj?.name || creator;
              const creatorImg = creatorObj?.image || defaultAvatar;

              groupFilters.appendChild(createFilterLabel(creatorName, handleizedName, creatorImg));
            });
          }
        });

        // Append no results message
        const noResultsMessage = document.createElement('p');
        noResultsMessage.className = 'mt-activities-filters__no-results hidden';
        noResultsMessage.innerText = window.activitiesTranslations.noResults;
        groupFilters.appendChild(noResultsMessage);

        // Apply preselected filter flag
        const preselected = _this.el.section.dataset.filtersPreselected;
        if (preselected && preselected.startsWith(`${group.dataset.type}:`)) {
          group.classList.add('inactive');
        }

        // Assemble group
        groupContent.append(groupSearch, groupSummary, groupFilters);
        group.append(groupTitle, groupContent);
        _this.el.filtersGroupsWrapper.appendChild(group);
      });

      // Helper functions
      function createFilterLabel(labelText, name, image = null) {
        const label = document.createElement('label');
        label.className = 'mt-activities-filters__filter';

        if (image) {
          label.classList.add('mt-activities-filters__filter--sub');
          label.innerHTML = `
            <figure class="mt-activities-filters__filter-icon"><img src="${image}" alt="${labelText}"></figure>
            <span class="mt-activities-filters__filter-label">${labelText}</span>
            <input type="checkbox" name="${name}[]" value="${labelText}">
            <span class="mt-activities-filters__filter-checkbox"></span>
          `;
        } else {
          label.innerHTML = `
            <span class="mt-activities-filters__filter-label">${labelText}</span>
            <input type="checkbox" name="${name}[]" value="${labelText}">
            <span class="mt-activities-filters__filter-checkbox"></span>
          `;
        }

        return label;
      }

      function resetFilterGroups() {
        _this.el.filtersGroups.forEach(g => {
          g.removeAttribute('open');
          g.classList.remove('hidden');
      
          const searchInput = g.querySelector('.mt-activities-filters__group-search__input');
          if (searchInput) {
            searchInput.value = '';
            searchInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
      
          const selectedOptions = g.querySelectorAll('.mt-activities-filters__filter.is-checked');
          selectedOptions.forEach(opt => {
            opt.classList.add('is-first');
          });
        });
      
        _this.el.filtersGroupsTitle.innerText = _this.el.filtersGroupsTitle.dataset.tDefault;
        _this.el.filtersGroupsClear.classList.remove('hidden');
        _this.el.filtersGroupsClear.dataset.clear = 'all';
        _this.el.filtersGroupsClear.dataset.count = _this.filters.allFiltersCount;
        _this.el.filtersGroupsClear.querySelector('span').innerText = window.activitiesTranslations.clearAll;
        _this.el.filtersBackBtn.classList.add('hidden');
      }

      // Filters
      document.addEventListener('click', e => !e.target.closest('.mt-activities-list__filters') && _this.el.section.classList.remove('mt-activities-list--filters'));
      _this.el.filtersToggleBtn.addEventListener('click', () => _this.el.section.classList.toggle('mt-activities-list--filters'));
      _this.el.filtersClearBtns = document.querySelectorAll('[data-clear]');
      _this.el.filtersClearBtns.forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          _this.filters.clear(true, btn.dataset.clear);
        });
      });
      _this.el.filtersBackBtn.addEventListener('click', e => {
        e.preventDefault();
        resetFilterGroups();
      });
      _this.el.filtersOverlay.addEventListener('click', () => {
        _this.el.section.classList.remove('mt-activities-list--filters');
        resetFilterGroups();
      });
      _this.el.filtersGroups = document.querySelectorAll('.mt-activities-filters__group');
      _this.el.filtersGroups.forEach(group => {
        const summary = group.querySelector('.mt-activities-filters__group-title');
        summary.addEventListener('click', () => {
          _this.el.filtersGroups.forEach(g => {
            if (group !== g) {
              g.removeAttribute('open');
              g.classList.toggle('hidden', !group.hasAttribute('open'));
            } else {
              const groupCount = g.querySelector('.mt-activities-filters__group-title span[data-count]');
              _this.el.filtersGroupsTitle.innerText = group.innerText;
              _this.el.filtersGroupsClear.classList.remove('hidden');
              _this.el.filtersGroupsClear.dataset.clear = group.dataset.type;
              _this.el.filtersGroupsClear.dataset.count = groupCount.dataset.count;
              _this.el.filtersGroupsClear.querySelector('span').innerText = window.activitiesTranslations.clear;
              _this.el.filtersBackBtn.classList.remove('hidden');
            }
          });
          if (group.getAttribute('open') === '') {
            const groupSelectedOptions = group.querySelectorAll('.mt-activities-filters__filter.is-checked');
            groupSelectedOptions.forEach(gso => {
              gso.classList.add('is-first');
            });
          }
        });

        const groupFilters = group.querySelector('.mt-activities-filters__group-search__input');
        const groupFiltersMessage = group.querySelector('.mt-activities-filters__no-results');
        const groupFiltersButton = group.querySelector('.mt-activities-filters__group-search__button');
        groupFilters.addEventListener('input', e => {
          const searchValue = e.target.value.toLowerCase().trim();
          const filters = group.querySelectorAll('.mt-activities-filters__filter');
          filters.forEach(filter => {
            const filterLabel = filter.querySelector('.mt-activities-filters__filter-label').innerText.toLowerCase();
            filter.classList.toggle('hidden', !filterLabel.includes(searchValue));
          });
          const visibleFilters = group.querySelectorAll('.mt-activities-filters__filter:not(.hidden)');
          groupFiltersMessage.classList.toggle('hidden', visibleFilters.length > 0);
          groupFiltersButton.classList.toggle('is-active', searchValue.length > 0);
        });
        groupFiltersButton.addEventListener('click', () => {
          groupFilters.value = '';
          groupFilters.dispatchEvent(new Event('input'));
          groupFiltersButton.classList.remove('is-active');
        });
      });

      // Sticky filters
      let lastScrollTop = 0;
      const stickyFilters = () => {
        const sectionPosition = _this.el.section.getBoundingClientRect().top + document.documentElement.scrollTop;
        const currentScrollTop = window.scrollY;
      
        if (currentScrollTop > sectionPosition) {
          _this.el.filtersWrapper.classList.add('sticky');
        } else {
          _this.el.filtersWrapper.classList.remove('sticky');
        }

        _this.el.filtersWrapper.classList.toggle('sticky-visible', currentScrollTop < lastScrollTop);
      
        lastScrollTop = currentScrollTop;
      };
      stickyFilters();
      window.addEventListener('scroll', () => stickyFilters());

      // Events
      const creatorsConfig = app.activitiesList.creatorsConfig;
      const filtersWrapper = _this.el.filters.closest('.mt-activities-list__filters-wrapper');
      const inputs = _this.el.filters.querySelectorAll('input');
      inputs.forEach(input => {
        const creatorsGroups = creatorsConfig.filter(group => group.title === input.value || group.includes.includes(input.value));
        const group = input.closest('.mt-activities-filters__group');
        const label = input.closest('.mt-activities-filters__filter');
        input.addEventListener('change', () => {
          if (label) {
            label.classList.remove('active-partially');
            label.classList.toggle('is-checked', input.checked);
            label.classList.remove('is-first');
          }

          // Creators groups
          if (input.name === 'creators[]' && creatorsGroups.length > 0) {
            const groupName = creatorsGroups[0].title;
            const groupInput = document.querySelector(`input[name="creators[]"][value="${groupName}"]`);
            const group = creatorsConfig.find(i => i.title === groupName)?.includes;
            const filterInputs = document.querySelectorAll(`input[name="creators[]"][value="${input.value}"]`);
            if (input.value === groupName) {
              const creatorsGroup = [];
              group.forEach(creator => {
                const creators = document.querySelectorAll(`input[name="creators[]"][value="${creator}"]`);
                creatorsGroup.push(...creators);
              });
              creatorsGroup.forEach(creator => {
                const creatorLabel = creator.closest('.mt-activities-filters__filter');
                creator.checked = input.checked;
                creatorLabel.classList.toggle('is-checked', creator.checked);
              });
            } else {
              (input.checked == false) && (groupInput.checked = false);
              filterInputs.forEach(i => (i.checked = input.checked));
            }
          }

          // Update quick filters
          const featuredFilter = document.querySelector(`.mt-featured-filters__item input[name="${input.name}"][value="${input.value}"]`);
          featuredFilter && (featuredFilter.checked = input.checked);

          // Filter
          _this.filters.filter(null, input.name);

          // DL events
          if (!input.dataset.event || input.dataset.event == 'true') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'filter_click',
              filter_category: group.dataset.type,
              filter_value: input.value
            });
          } else {
            input.dataset.event = true;
          }
        });
      });
      filtersWrapper?.classList.remove('loading');
      _this.filters.parseEntryUrl();
    }
  },

  creator: {
    el: {
      profile: document.querySelector('.mt-activities-list__creator'),
      profileBackBtn: document.querySelector('.mt-activities-list__creator-back'),
      profileCover: document.querySelector('.mt-activities-list__creator-cover'),
      profileAvatar: document.querySelector('.mt-activities-list__creator-avatar'),
      profileTitle: document.querySelector('.mt-activities-list__creator-title'),
      profileSubtitle: document.querySelector('.mt-activities-list__creator-subtitle'),
      profileDescription: document.querySelector('.mt-activities-list__creator-description p'),
      profileUrls: document.querySelector('.mt-activities-list__creator-urls'),
      profileDrills: document.querySelector('.mt-activities-list__creator-drills'),
      box: document.querySelector('.mt-activity-creator-box'),
      boxAvatar: document.querySelector('.mt-activity-creator-box__avatar img'),
      boxTitle: document.querySelector('.mt-activity-creator-box__title'),
      boxSubtitle: document.querySelector('.mt-activity-creator-box__subtitle'),
      boxDescription: document.querySelector('.mt-activity-creator-box__description p'),
      boxBtn: document.querySelector('.mt-activity-creator-box__action-link')
    },

    show: function (type = 'box') {
      const _this = this;
      if (_this.el[type]) {
        _this.el[type].classList.remove('hidden');

        if (type === 'profile') {
          app.activitiesList.el.body.classList.add('training-hub-profile');
          window.scroll({ top: 0, left: 0, behavior: 'instant' });

          // DL events
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'creator_profile_view',
            creator_name: _this.el.profileTitle.innerText
          });
        }
      }
    },

    hide: function (type = 'box') {
      const _this = this;
      if (_this.el.profile && _this.el.profile.dataset.profile === 'true') return;

      _this.el[type] && _this.el[type].classList.add('hidden');
      (type == 'profile') && app.activitiesList.el.body.classList.remove('training-hub-profile');
    },

    update: function (c = {}, showType = null, force = false) {
      const _this = this;
      if (!c.author) return;
      if (_this.el.profile && _this.el.profile.dataset.profile === 'true' && force === false) return;

      const recognizePlatform = url => {
        if (url.includes("facebook.com")) return "facebook";
        if (url.includes("instagram.com")) return "instagram";
        if (url.includes("twitter.com") || url.includes("x.com")) return "twitter";
        if (url.includes("youtube.com") || url.includes("youtu.be")) return "youtube";
        if (url.includes("tiktok.com")) return "tiktok";
        if (url.includes("linkedin.com")) return "linkedin";
        return 'website';
      };
      const defaultAvatar = window.activitesCreatorsAvatar ? window.activitesCreatorsAvatar : '';
      const appUserId = c.appId || '9999';
      const appUserName = c.author;
      const creatorObj = activitiesCreators.find(cr => cr.app_id === appUserId) || (activitiesCreators.find(cr => cr.name === appUserName) || { name: appUserName, subtitle: '', image: defaultAvatar });
      const creatorUrls = creatorObj?.additional_urls || [];

      // Update box
      _this.el.boxAvatar.src = creatorObj.image || '';
      _this.el.boxTitle.innerHTML = creatorObj.name || '';
      _this.el.boxSubtitle.innerHTML = creatorObj.subtitle || '';
      _this.el.boxDescription.innerHTML = creatorObj.description || '';
      _this.el.boxBtn.dataset.creator = creatorObj.name;
      _this.el.boxBtn.dataset.page = (creatorObj.handle && !creatorObj.handle.includes('th-creator')) ? `${window.Shopify.routes.root}pages/training-hub/${creatorObj.handle}` : '';

      // Update profile
      _this.el.profile.classList.toggle('mt-activities-list__creator--no-cover', !creatorObj.cover);
      _this.el.profileCover.innerHTML = creatorObj.cover ? `<img src="${creatorObj.cover}" alt="">` : '';
      _this.el.profileAvatar.innerHTML = creatorObj.image ? `<img src="${creatorObj.image}" alt="">` : '';
      _this.el.profileTitle.innerHTML = creatorObj.name || '';
      _this.el.profileSubtitle.innerHTML = creatorObj.subtitle || '';
      _this.el.profileDescription.innerHTML = creatorObj.description || '';
      _this.el.profileDrills.classList.toggle('hidden', (app.activitiesList.filters.availableItems === 0));
      _this.el.profileDrills.innerHTML = window.activitiesTranslations.showingDrills.replace('{count}', app.activitiesList.filters.availableItems);

      let profileUrlsHtml = '';
      creatorUrls.forEach(url => {
        const platform = recognizePlatform(url);
        const icon = document.querySelector(`.mt-activites-icons .mt-icon--${platform}`);
        profileUrlsHtml += `<li><a href="${url}" target="_blank" title="${platform}">${icon.outerHTML}</a></li>`;
      });
      _this.el.profileUrls.innerHTML = profileUrlsHtml;

      // Update box location
      if (c.item) {
        const itemRect = c.item.getBoundingClientRect();
        const itemPosition = {
          top: itemRect.top + window.scrollY,
          left: itemRect.left + window.scrollX
        };
        _this.el.box.style.top = itemPosition.top + 64 + 'px';
        _this.el.box.style.left = itemPosition.left + (itemRect.width - 32) - (_this.el.box.offsetWidth / 2) + 'px';
        _this.el.box.classList.remove('to-right');
  
        const boxRect = _this.el.box.getBoundingClientRect();
        const isBoxOverflowing = boxRect.right > window.innerWidth;
        if (isBoxOverflowing) {
          _this.el.box.style.left = itemPosition.left + itemRect.width - _this.el.box.offsetWidth + 24 + 'px';
          _this.el.box.classList.add('to-right');
        }
      }

      // Additional events
      const profileUrls = _this.el.profileUrls.querySelectorAll('a');
      profileUrls.forEach(url => {
        url.addEventListener('click', () => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'creator_social_links_click',
            creator_name: creatorObj.name,
            link_text: url.innerText
          });
        }, { once: true });
      });

      (showType !== null) && setTimeout(() => _this.show(showType), 75);
    },

    filter: function (creator = null) {
      const _this = this;
      if (creator === null) return;

      const filter = document.querySelector(`.mt-activities-filters__group input[name="creators[]"][value="${creator}"]`);
      if (!filter) return;
      const filterLabel = filter.closest('.mt-activities-filters__filter');

      app.activitiesList.filters.clear(true, 'all');
      filterLabel.classList.add('is-checked');
      filter.checked = true;
      filter.dataset.event = false;
      filter.dispatchEvent(new Event('change'));

      setTimeout(() => {
        _this.hide('box');
        _this.show('profile');
      }, 150);
    },

    init: function() {
      const _this = this;
      
      // Explore button
      _this.el.boxBtn.addEventListener('click', e => {
        e.preventDefault();

        if (_this.el.boxBtn.dataset.page && _this.el.boxBtn.dataset.page !== '') {
          window.location.href = _this.el.boxBtn.dataset.page;
          return;
        }

        _this.filter(_this.el.boxBtn.dataset.creator);
        _this.update({
          author: _this.el.boxBtn.dataset.creator,
        });
      });

      // Back button
      _this.el.profileBackBtn.addEventListener('click', (e) => {
        e.preventDefault();

        if (document.querySelector('.template-th_creator')) {
          window.location.href = `${window.Shopify.routes.root}pages/training-hub`;
          return;
        }

        app.activitiesList.filters.clear(true, 'all');
        _this.hide('profile');
      });
    }
  },

  tooltip: {
    el: {
      copy: document.querySelector('.mt-share-box__item--copy'),
      whatsapp: document.querySelector('.mt-share-box__item--whatsapp'),
      messenger: document.querySelector('.mt-share-box__item--messenger'),
      facebook: document.querySelector('.mt-share-box__item--facebook'),
      twitter: document.querySelector('.mt-share-box__item--twitter-x'),
      instagram: document.querySelector('.mt-share-box__item--instagram')
    },

    update: function (text = '', link = null) {
      const _this = this;
      if (link === null) return;
      
      _this.el.copy.href = link;
      _this.el.whatsapp.href = (window.innerWidth <= 550) ? `whatsapp://send?text=${link}` : `https://web.whatsapp.com/send?text=${link}`;
      _this.el.messenger.href = `fb-messenger://share/?link=${link}`;
      _this.el.facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${link}`;
      _this.el.twitter.href = `https://twitter.com/share?url=${link}&hashtags=blazepod`;
      _this.el.instagram.href = `instagram://sharesheet?text=${link}`;
    },

    init: function() {
      const _this = this;

      if (_this.el.copy) {
        const copyText = _this.el.copy.querySelector('span');
        const defaultText = copyText.innerText;
        _this.el.copy.addEventListener('click', e => {
          e.preventDefault();
          navigator.clipboard?.writeText(_this.el.copy.href);
          copyText.innerText = 'Copied';
          setTimeout(() => {
            copyText.innerText = defaultText;
          }, 1500);
        });
      }
    }
  },

  loadMore: {
    update: function () {
      const _this = app.activitiesList;
      const hiddenActivities = document.querySelectorAll('.mt-activity.hidden[data-filter-visible="1"]');

      if (hiddenActivities.length === 0) {
        _this.el.loadMoreWrapper.classList.add('hidden');
      } else {
        _this.el.loadMoreWrapper.classList.remove('hidden');
      }
    },

    init: function () {
      const _this = this;
      const itemsPerPage = Number(app.activitiesList.el.content.dataset.loadMore);
      let hiddenActivities = document.querySelectorAll('.mt-activity.hidden[data-filter-visible="1"]');

      // Load more
      app.activitiesList.el.loadMore.addEventListener('click', e => {
        e.preventDefault();

        hiddenActivities = document.querySelectorAll('.mt-activity.hidden[data-filter-visible="1"]');
        if (hiddenActivities.length > 0) {
          for (let i = 0; i < itemsPerPage; i++) {
            hiddenActivities[i] && hiddenActivities[i].classList.remove('hidden');
          }
          hiddenActivities = document.querySelectorAll('.mt-activity.hidden[data-filter-visible="1"]');
          _this.update();
          window.dispatchEvent(new Event('resize'));

          // DL Events
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'load_more_videos_click'
          });
        }
      });

      // Infinity scroll
      const observeActionButton = () => {
        const target = document.querySelector('.mt-activities-list__action');
        if (!target) return;
    
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            entry.isIntersecting && app.activitiesList.el.loadMore.dispatchEvent(new Event('click'));
          });
        }, { root: null, threshold: 1, rootMargin: '0px 0px -50px 0px' });
    
        observer.observe(target);
      }
      observeActionButton();

      _this.update();
    }
  },

  utilities: {
    callFnWhenAvailable: (fnPath, callback, checkInterval = 50, timeout = 5000) => {
      const startTime = Date.now();
      const checkAvailability = () => {
        const fn = fnPath.split('.').reduce((acc, part) => acc?.[part], window);
        if (typeof fn === 'function') {
          callback(fn);
        } else if (Date.now() - startTime < timeout) {
          setTimeout(checkAvailability, checkInterval);
        } else {
          console.error(`Function ${fnPath} not available within ${timeout}ms`);
        }
      };
    
      checkAvailability();
    },

    handleize: function (str) {
      return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
    },

    updateFilterState: function (input, isChecked) {
      const label = input.closest('.mt-activities-filters__filter');
      label?.classList.toggle('is-checked', isChecked);
      input.checked = isChecked;
    }
  },

  init: async function () {
    const _this = this;
    const now = new Date().getTime();
    let actualData = true;
    (_this.data.length === 0 || _this.filtersData.length === 0) && (actualData = false);
    if (now >= (_this.lastUpdated + 3600000)) {
      actualData = false;
      _this.data = [];
      _this.filtersData = [];
      _this.lastUpdated = null;
    };
    (!actualData) && await _this.fetchActivites();
    _this.render();
    (!actualData) && await _this.fetchFilters();
    _this.filters.init();
    _this.quickFilters();
  }
}
window.app.activitiesList.init();